export default "/_next/static/node_modules/@riot-private/blades-ui/dist/skins/common/assets/media-square.svg";